import React, { useState } from 'react';
import axios from 'axios';
import Breadcrumbs from '../../../components/Common/Breadcrumb';
import {
  Row,
  Col,
  Card,
  CardBody,
  Container,
} from 'reactstrap';
import GetRequestComponent from '../../../components/Common/GetRequest';
const GetMembershipDetail = () => {
    const [url, setUrl] = useState('');
    const [requestBody, setRequestBody] = useState('');
    const [response, setResponse] = useState(null);
    const [breadcrumbItems] = useState([
      { title: 'Membership', link: '#' },
      { title: 'Get Membership Details', link: '#' }
    ]);
    const headers=[
      {
        title:'apikey',
        type:'text',
        required:true,
      }
    ]
    const urlparams=[
      {
        title:'membership_id',
        type:'text',
        required:true
      }
    ]
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
        <Breadcrumbs
            title="Get Membership Details"
            breadcrumbItems={breadcrumbItems}
          />
          <p>To Get A Membership Deatils Purchased by the Shop. Fields marked with <span style={{color:"red"}}>*</span> are required</p>
      <GetRequestComponent title="Get Membership Details" headers={headers} urlparams={urlparams} url='/v2/tp/membership/:membership_id'/>
      </Container>
      </div>
    </React.Fragment>
  )
}

export default GetMembershipDetail;